"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _VisitRecord = _interopRequireDefault(require("customer-data-objects/visit/VisitRecord"));

var _react = require("react");

var VisitType = _react.PropTypes.instanceOf(_VisitRecord.default);

var _default = VisitType;
exports.default = _default;
module.exports = exports.default;